export const FARM_CONTACTS = {
  primary: {
    name: "Rahmatullah",
    phone: "923072260256",
    display: "+92 307 2260256",
  },
  secondary: {
    name: "Abdul Raheem",
    phone: "923072828026",
    display: "+92 307 2828026",
  },
} as const;

export const FARM_EMAIL = "bugtirahmatullah@gmail.com";
export const FARM_ADDRESS = "Village Deen Muhammad Bugti, Daur, Pakistan";

export const EID_UL_ADHA_2026 = new Date("2026-05-27T00:00:00+05:00").getTime();
/** Provisional Pakistan-local midnight; confirm when official Eid-ul-Adha 2027 is announced. */
export const EID_UL_ADHA_2027 = new Date("2027-06-06T00:00:00+05:00").getTime();

export type WhatsAppContext =
  | "hero"
  | "breed_tedda"
  | "breed_gulabi"
  | "breed_kamori"
  | "qurbani"
  | "farm_visit"
  | "general"
  | "portal_demo"
  | "final_cta";

const MESSAGES: Record<WhatsAppContext, string> = {
  hero:
    "Assalam-o-Alaikum! Qurbani 2027 (ya agar 2026 ke liye koi janwar bacha ho) ke liye completely self-feed bakra book karna hai. Rates aur availability bhej dein. Shukriya.",
  breed_tedda:
    "Assalam-o-Alaikum! Qurbani ke liye Tedda chahiye — completely self-feed. Photos aur rate bhej dein.",
  breed_gulabi:
    "Assalam-o-Alaikum! Qurbani ke liye Gulabi chahiye — completely self-feed. Photos aur rate bhej dein.",
  breed_kamori:
    "Assalam-o-Alaikum! Qurbani ke liye Kamori ke baare mein maloomat chahiye — completely self-feed.",
  qurbani:
    "Assalam-o-Alaikum! Qurbani 2027 ke liye bakra reserve karna hai (2026 ke liye bhi agar stock ho). Completely self-feed; details aur available animals bhej dein. Shukriya.",
  farm_visit:
    "Assalam-o-Alaikum! Farm visit ke liye appointment lena hai. Kab available ho?",
  general: "Assalam-o-Alaikum! Mujhe Alraheem Goat Farm ke baare mein maloomat chahiye.",
  portal_demo:
    "Assalam-o-Alaikum! Main ne website pe live tracking demo dekha. Mujhe bakra book karna hai.",
  final_cta:
    "Assalam-o-Alaikum! Alraheem Goat Farm se Qurbani 2027 (ya 2026 agar available ho) ke liye bakra book karna hai.",
};

export function getWhatsAppLink(
  context: WhatsAppContext = "general",
  phone: string = FARM_CONTACTS.primary.phone
): string {
  const text = encodeURIComponent(MESSAGES[context]);
  return `https://wa.me/${phone}?text=${text}`;
}

export function openWhatsApp(context: WhatsAppContext = "general") {
  const url = getWhatsAppLink(context);
  window.open(url, "_blank", "noopener,noreferrer");
}
